<template>
  <v-list class="pt-0">
    <v-row>
      <v-col cols="11" class="pt-0">
        <Pagination v-model="indexesHistory" @navigateBackward="goBackward" />
      </v-col>
    </v-row>
    <v-divider/>
    <flash-message></flash-message>
    <v-overlay :value="loadingError" :opacity="0">
      <v-subheader class="foreground--text">Não foi possível carregar os dados</v-subheader>
    </v-overlay>
    <v-overlay :value="notInicialized" :opacity="0">
      <v-subheader class="foreground--text">Seu Drive não foi iniciado, entre em contato pelo Atendimento.</v-subheader>
    </v-overlay>
    <div v-show="notInicializedSalesforce" class="overlayNotInicializedSf">
      <v-subheader class="foreground--text">Seu Drive não foi iniciado, entre em contato pelo Atendimento.</v-subheader>
    </div>
    <v-overlay :value="isLoadingContent" :opacity="0">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <template v-if="!isLoadingContent && !isLoadingError">
      <GenericInformation :open="detaillingItem" :item="itemToDetail" @close="detaillingItem = false"/>
      <DeletionConfirmationModal
        :open="deletingItem"
        :item="itemToDelete"
        @close="stopDeletingItem"
        @confirm="confirmItemDeletion"
      />
      <RenamingModal
        :open="renamingItem"
        :item="itemToRename"
        @close="stopRenamingItem"
        @confirm="confirmItemRenaming"
      />
      <GenericFilesExplorerMobile
        :loadingError="loadingError"
        :notInicialized="notInicialized"
        :notInicializedSalesforce="notInicializedSalesforce"
        :allowCreate="allowCreate"
        :allowUpload="allowUpload"
        :allowRename="allowRename"
        :allowDelete="allowDelete"
        :folders="folders"
        :files="files"
        @create-folder="createFolder"
        @upload="uploadFiles"
        @forward="goForward"
        @showAccessPermission="showAccessPermission"
        @showNotification="showNotification"
        @informations="showItemInformations"
        @download="downloadFile"
        @downloadAllFiles="downloadAllFiles"
        @delete="deleteItem"
        @rename="renameItem"
        @error="showInvalidFiles"
      />
    </template>
  </v-list>
</template>

<script>
import saveAs from 'file-saver';
import GenericInformation from '@/components/generic-information/index.vue';
import Pagination from '@/components/pagination/index.vue';
import DeletionConfirmationModal from '@/components/deletion-confirmation-modal/index.vue';
import RenamingModal from '@/components/renaming-modal/index.vue';
import {
  createDirectory, deleteDirectory, getDirectoryAccessPermission, downloadFile, downloadFileZip, deleteFile,
  renameFile, uploadFile, MESSAGE_ERRO, MESSAGE_NOT_AUTORIZED,
  EMPTY_DIRECTORY, MESSAGE_FILE_EXISTING, MESSAGE_FOLDER_EXISTING, FAILED_LOAD_FILES,
} from '@/common/driveserver';
import AttachmentMixins from '@/shared/mixins/attachmentMixins';
import FileMixin from '@/shared/mixins/fileMixin';
import GenericFilesExplorerMobile from './generic-file-explorer.vue';

export default {
  name: 'GenericFilesExplorer',
  components: {
    GenericFilesExplorerMobile,
    GenericInformation,
    Pagination,
    DeletionConfirmationModal,
    RenamingModal,
  },
  props: {
    content: {
      type: Object,
    },
    loadingContent: {
      type: Boolean,
    },
    loadingError: {
      type: Boolean,
      required: true,
    },
    notInicialized: {
      type: Boolean,
      required: true,
    },
    notInicializedSalesforce: {
      type: Boolean,
      required: true,
    },
    allowCreate: {
      type: Boolean,
      required: true,
    },
    allowDelete: {
      type: Boolean,
      required: true,
    },
    allowRename: {
      type: Boolean,
      required: true,
    },
    allowUpload: {
      type: Boolean,
      required: true,
    },
    indexesHistoryProps: {
      type: Array,
      required: false,
    },
  },
  data: () => ({
    count: 0,
    itemsProcessed: 1,
    errosFile: [],
    isLoadingContent: true,
    isLoadingError: false,
    configuredContent: [],
    currentPath: '',
    indexesHistory: [{
      index: 0,
      name: 'Home',
      path: '',
      icon: 'mdi-home',
    }],
    detaillingItem: false,
    deletingItem: false,
    itemToDelete: {},
    renamingItem: false,
    itemToRename: {},
    itemToDetail: {},
  }),
  mixins: [
    AttachmentMixins,
    FileMixin,
  ],
  created() {
    this.indexesHistory = this.indexesHistoryProps || this.indexesHistory;
  },
  computed: {
    folders() {
      return this.configuredContent.filter((item) => item.type === 'FOLDER');
    },
    files() {
      return this.configuredContent.filter((item) => item.type === 'FILE');
    },
  },
  methods: {
    goForward(newIndex) {
      if (this.detaillingItem) {
        return;
      }
      if (newIndex >= 0) {
        const folderToNavigateTo = this.folders[newIndex];
        this.indexesHistory.push({
          index: newIndex,
          name: folderToNavigateTo.name,
          path: folderToNavigateTo.path,
        });
        this.showLoad();
        this.getDirectoryService(folderToNavigateTo.path);
        this.currentPath = folderToNavigateTo.path;
      }
    },
    goBackward(to) {
      if (to === 0) {
        this.goToIndexHistoryInitial();
        this.showLoad();
        this.getDirectoryService();
      } else {
        if (to === this.indexesHistory.length - 1) {
          return;
        }
        const pathToCut = [];
        this.indexesHistory.forEach((item, index) => {
          if (index <= to) {
            pathToCut.push(item);
          }
        });
        this.getDirectoryService(this.indexesHistory[to].path);
        this.currentPath = this.indexesHistory[to].path;
        this.indexesHistory = pathToCut;
      }
    },
    goToIndexHistoryInitial() {
      this.currentPath = '';
      this.indexesHistory = [{
        index: 0,
        name: 'Home',
        path: '',
        icon: 'mdi-home',
      }];
    },
    getDirectoryService(path = '') {
      this.showLoad();
      getDirectoryAccessPermission(path)
        .then((response) => {
          this.configuredContent = response.data.files;
          this.allowCreate = response.data.allowCreate;
          this.allowDelete = response.data.allowDelete;
          this.allowRename = response.data.allowRename;
          this.allowUpload = response.data.allowUpload;
        })
        .catch((error) => {
          this.showMessageErro(error);
        })
        .finally(() => { this.hiddenLoad(); });
    },
    traverseItems(itemsToTraverse, indexToReach) {
      let itemToReturn;
      itemsToTraverse.forEach((item, index) => {
        if (index === indexToReach) {
          itemToReturn = item;
        }
      });
      return itemToReturn;
    },
    traversePath(pathToTraverse) {
      let itemsToTraverse = this.content;
      let lastItemFound;
      pathToTraverse.forEach((pathIndex) => {
        lastItemFound = this.traverseItems(itemsToTraverse, pathIndex);
        itemsToTraverse = lastItemFound.content;
      });
      return lastItemFound;
    },
    showItemInformations(file) {
      this.detaillingItem = true;
      this.itemToDetail = file;
    },
    showAccessPermission(item) {
      const { token } = this.$route.query;
      this.$router.push({ name: 'show-access-permission', params: { item, token, indexesHistoryProps: this.indexesHistory }, query: { token } });
    },
    showNotification(item) {
      const { token } = this.$route.query;
      this.$router.push({ name: 'show-notification', params: { item, token, indexesHistoryProps: this.indexesHistory }, query: { token } });
    },
    downloadAllFiles(files) {
      const allowedFiles = files.map((file) => ({
        ...file,
        selected: true,
      }));

      const basePath = this.commonPath(allowedFiles.map((f) => f.path));

      const file = { path: basePath };

      this.downloadFile(file, allowedFiles);
    },
    downloadFile(file, files) {
      this.showLoad();
      const selectedFiles = files.filter((f) => f.selected === true).map((f) => f.path);
      if (selectedFiles.length > 1) {
        downloadFileZip(file.path, selectedFiles)
          .then((response) => {
            const { path } = file;
            const parts = path.split('/');
            const path1 = parts[parts.length - 2] || 'Arquivos';
            saveAs(new Blob([response.data]), `${path1}.zip`);
          })
          .catch((error) => { this.showMessageErro(error); })
          .finally(() => { this.hiddenLoad(); });
      } else {
        downloadFile(file.path, selectedFiles)
          .then((response) => {
            saveAs(new Blob([response.data]), file.name);
          })
          .catch((error) => { this.showMessageErro(error); })
          .finally(() => { this.hiddenLoad(); });
      }
    },
    deleteItem(file) {
      this.itemToDelete = file;
      this.deletingItem = true;
    },
    stopDeletingItem() {
      this.deletingItem = false;
      this.itemToDelete = {};
    },
    confirmItemDeletion() {
      this.deletingItem = false;
      if (this.itemToDelete.type === 'FOLDER') {
        this.deleteDirectoryService();
      } else {
        this.deleteDirectoryFile();
      }
    },
    deleteDirectoryService() {
      this.showLoad();
      deleteDirectory(this.itemToDelete.path, this.itemToDelete.name)
        .then(() => {
          const index = this.findObject(this.itemToDelete.path, this.itemToDelete.name);
          this.configuredContent.splice(index, 1);
        })
        .catch((error) => { this.showMessageErro(error); })
        .finally(() => { this.hiddenLoad(); });
    },
    deleteDirectoryFile() {
      this.showLoad();
      deleteFile(this.itemToDelete.path, this.itemToDelete.name)
        .then(() => {
          const index = this.findObject(this.itemToDelete.path);
          this.configuredContent.splice(index, 1);
        })
        .catch((error) => { this.showMessageErro(error); })
        .finally(() => { this.hiddenLoad(); });
    },
    renameItem(file) {
      this.itemToRename = file;
      this.renamingItem = true;
    },
    stopRenamingItem() {
      this.renamingItem = false;
      this.itemToRename = {};
    },
    confirmItemRenaming(newName = 'newName') {
      this.renamingItem = false;
      this.renameFileService(newName);
    },
    renameFileService(newName) {
      this.showLoad();
      const path = this.itemToRename.path.replace(this.itemToRename.name, '');
      renameFile(path, newName, this.itemToRename.name)
        .then((response) => {
          const index = this.findObject(this.itemToRename.path);
          this.configuredContent[index].name = response.data.name;
          this.configuredContent[index].path = path.concat(response.data.name);
          this.configuredContent[index].modified = response.data.modified;
        })
        .catch((error) => {
          this.showMessageErro(error);
        })
        .finally(() => { this.hiddenLoad(); this.itemToRename = {}; });
    },
    uploadFiles(selectedFiles) {
      this.showLoad();
      this.count = selectedFiles.length;
      this.itemsProcessed = 1;
      this.errosFile = [];

      if (!this.validateBase64FilesSize(selectedFiles)) return;

      selectedFiles.forEach((item, index) => {
        this.uploadFileService(selectedFiles[index], this.currentPath, selectedFiles, index);
      });
    },
    uploadFileService(file, pathFile, selectedFiles, index) {
      uploadFile(pathFile, file.name, file.body, file.data)
        .then((response) => {
          this.configuredContent.push({
            name: decodeURI(response.data.name),
            path: decodeURI(pathFile.concat('/').concat(response.data.name)),
            type: response.data.type,
            created: response.data.created,
            modified: response.data.modified,
            userName: decodeURI(response.data.userName),
            userNameUpdate: decodeURI(response.data.userNameUpdate),
            size: response.data.size,
            content: [],
          });
          selectedFiles.splice(index, 1);
        })
        .catch((error) => {
          this.errosFile.push({
            name: file.name,
            status: error.response.status,
            error: error.response,
          });
        })
        .finally(() => {
          if (this.itemsProcessed === this.count) {
            this.hiddenLoad();
            const invalidFiles = [];
            const fileExisting = [];
            const fileFailed = [];
            this.errosFile.forEach((item) => {
              switch (item.status) {
                case 409:
                  fileExisting.push(item.name);
                  break;

                case 413:
                  invalidFiles.push(item);
                  break;

                default:
                  fileFailed.push(item.name);
              }
            });
            if (fileExisting.length > 0) {
              this.flash(`${MESSAGE_FILE_EXISTING}: ${fileExisting.toString()}`, 'error', { timeout: 5000 });
            }

            if (fileFailed.length > 0) {
              this.flash(`${FAILED_LOAD_FILES}: ${fileFailed.toString()}`, 'error', { timeout: 5000 });
            }

            if (invalidFiles.length > 0) {
              this.showServiceInvalidErrors(invalidFiles);
            }
          }
          this.itemsProcessed += 1;
        });
    },
    refreshFilesList(response) {
      response.forEach((item) => {
        this.configuredContent.push({
          name: decodeURI(item.name),
          path: decodeURI(this.currentPath.concat('/').concat(item.name)),
          type: item.type,
          created: item.created,
          modified: item.modified,
          userName: decodeURI(item.userName),
          userNameUpdate: decodeURI(item.userNameUpdate),
          size: item.size,
          content: [],
        });
      });
    },
    createFolder(folderName) {
      this.showLoad();
      const path = this.currentPath;
      createDirectory(path, folderName)
        .then((response) => {
          this.configuredContent.push({
            name: decodeURI(response.data.name),
            path: decodeURI(path.concat('/').concat(folderName)),
            type: response.data.type,
            created: response.data.created,
            modified: response.data.modified,
            userName: decodeURI(response.data.userName),
            userNameUpdate: decodeURI(response.data.userNameUpdate),
            size: response.data.size,
            content: [],
          });
        })
        .catch((error) => { this.showMessageErro(error); })
        .finally(() => { this.hiddenLoad(); });
    },
    findObject(path) {
      return this.configuredContent.findIndex((r) => r.path === path);
    },
    showLoad() {
      this.isLoadingContent = true;
    },
    hiddenLoad() {
      this.isLoadingContent = false;
    },
    showMessageErro(error) {
      this.hiddenLoad();
      let message;
      switch (error.response.status) {
        case 401:
          message = MESSAGE_NOT_AUTORIZED;
          break;
        case 409:
          if (error.response.data.toUpperCase() === 'RESOURCEALREADYEXISTS') {
            message = MESSAGE_FOLDER_EXISTING;
          }
          if (error.response.data.toUpperCase() === 'DIRECTORYNOTEMPTY') {
            message = EMPTY_DIRECTORY;
          }
          break;
        default:
          message = MESSAGE_ERRO;
      }
      this.flash(message, 'error', { timeout: 5000 });
    },
  },
  watch: {
    content(newContent) {
      this.configuredContent = newContent.files;
    },
    loadingContent(loadingContent) {
      this.isLoadingContent = loadingContent;
    },
  },
};

</script>

<style lang="scss">
  .overlayNotInicializedSf {
    position: absolute;
    top: 220px;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 300px;
  }
</style>
